module.exports = __webpack_public_path__ + "static/img/PS-NA3_80A.8bad772.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/PS-NA3_80A.png
// module id = me9Y
// module chunks = 1